import { Env } from "./ConfigInterface";

export type ProxyConfig = {
    snowProxyLiveAgentChatToken: string
    snowProxyLiveAgentChatApi: string
    myApprovalXProxy?: string
    jqlProxy: string
    entraidOboProxy: string
    snowRequestCallbackProxy: string
    beRequestCallbackProxy: string
    trueDemApiProxy?: string
}

const proxyConfigs: Record<Env, ProxyConfig> = {
    local: {
        snowProxyLiveAgentChatToken: "snow_live_agent_chat_token_dev",
        snowProxyLiveAgentChatApi: "snow_live_agent_chat_api_dev",
        myApprovalXProxy: "my_approval_dev",
        jqlProxy: "jira-preprod",
        entraidOboProxy: "entraid-obo-dev",
        snowRequestCallbackProxy: "snow_request_callback_dev",
        beRequestCallbackProxy: "be_request_callback_dev",
        trueDemApiProxy: "truedem_api",
    },
    dev: {
        snowProxyLiveAgentChatToken: "snow_live_agent_chat_token_dev",
        snowProxyLiveAgentChatApi: "snow_live_agent_chat_api_dev",
        myApprovalXProxy: "my_approval_dev",
        // jqlProxy: "jira-preprod"
        jqlProxy: "jira-preprod",
        entraidOboProxy: "entraid-obo-dev",
        snowRequestCallbackProxy: "snow_request_callback_dev",
        beRequestCallbackProxy: "be_request_callback_dev",
        trueDemApiProxy: "truedem_api",
    },
    qa: {
        snowProxyLiveAgentChatToken: "snow_live_agent_chat_token_pp",
        snowProxyLiveAgentChatApi: "snow_live_agent_chat_api_pp",
        jqlProxy: "jira-preprod",
        entraidOboProxy: "entraid-obo-dev",
        snowRequestCallbackProxy: "snow_request_callback_qa",
        beRequestCallbackProxy: "be_request_callback_qa",
        trueDemApiProxy: "truedem_api",
    },
    pp: {
        snowProxyLiveAgentChatToken: "snow_live_agent_chat_token_pp",
        snowProxyLiveAgentChatApi: "snow_live_agent_chat_api_pp",
        // jqlProxy: "jira-prod"
        jqlProxy: "jira-prod",
        entraidOboProxy: "entraid-obo-prod",
        snowRequestCallbackProxy: "snow_request_callback_pp",
        beRequestCallbackProxy: "be_request_callback_pp",
        trueDemApiProxy: "truedem_api",
    },
    prod: {
        snowProxyLiveAgentChatToken: "snow_live_agent_chat_token_prod",
        snowProxyLiveAgentChatApi: "snow_live_agent_chat_api_prod",
        jqlProxy: "jira-prod",
        entraidOboProxy: "entraid-obo-prod",
        snowRequestCallbackProxy: "snow_request_callback_prod",
        beRequestCallbackProxy: "be_request_callback_prod",
        trueDemApiProxy: "truedem_api",
    },
};

export default proxyConfigs;
